import { render, staticRenderFns } from "./LeavePlanForm.vue?vue&type=template&id=629d7fc4"
import script from "./LeavePlanForm.vue?vue&type=script&lang=js"
export * from "./LeavePlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports